import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import i18n from 'i18n-js';
import { Field } from 'formik';
import { useStyles } from '../ReservationRulesetCreate.styled';
import { TextField, MaterialSelectField } from 'components/FormFields';
import { useField } from 'formik';

const RuleField = ({ title, description, name, errors, editable = true }) => {
  const [magnitudeField] = useField(`${name}.magnitude`);
  const [unitsFiled] = useField(`${name}.units`);
  const classes = useStyles();
  const units = [
    { value: 'min', label: 'minute' },
    { value: 'hr', label: 'hour' },
    { value: 'd', label: 'day' },
    { value: 'week', label: 'week' },
    { value: 'month', label: 'month' },
  ];
  const labelMap = { min: 'minute', hr: 'hour', day: 'day', week: 'week', month: 'month' };

  return (
    <Grid container className={classes.ruleContainer} spacing={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="h6" align="right">
          <Box fontWeight="bold" fontSize={14}>
            {title}
          </Box>
        </Typography>
        <Typography variant="body1" align="right" className={classes.description}>
          {description}
        </Typography>
      </Grid>
      {editable ? (
        <>
          <Grid item xs={6} sm={3}>
            <Field
              data-cy={`${title.toLowerCase().split(' ').join('-')}-value`}
              margin="none"
              label={i18n.t('reservation_rulesets.value')}
              name={`${name}.magnitude`}
              component={TextField}
              inputProps={{ className: classes.input }}
              asyncErrors={errors?.[`${name}.magnitude`]}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <Field
              data-cy={`${title.toLowerCase().split(' ').join('-')}-unit`}
              margin="none"
              options={units}
              placeholder={i18n.t('reservation_rulesets.unit')}
              name={`${name}.units`}
              component={MaterialSelectField}
            />
          </Grid>
        </>
      ) : (
        <Grid item xs={12} sm={6}>
          <b>{`${magnitudeField.value} ${labelMap[unitsFiled.value] || unitsFiled.value}(s)`}</b>
        </Grid>
      )}
    </Grid>
  );
};

export { RuleField };
